
(function () {
  function moveHeroButtonGap() {
    const section = document.querySelector('.wt-video__movie--shopify-video');
    if (!section) return;

    const parent = section.querySelector('.hero__overlay__content');
    if (!parent) return;

    const gaps = parent.querySelectorAll(':scope > .hero__button--gap');
    if (gaps.length < 2) return;

    const firstGap = gaps[0];
    const secondGap = gaps[1];

    if (firstGap.contains(secondGap)) return;

    firstGap.appendChild(secondGap);
    firstGap.classList.add('hero-buttons-merged');

    console.log('Moved full second hero__button--gap inside first one');
  }

  document.addEventListener('DOMContentLoaded', moveHeroButtonGap);
  window.addEventListener('load', moveHeroButtonGap);

  document.addEventListener('shopify:section:load', moveHeroButtonGap);
  document.addEventListener('shopify:section:reorder', moveHeroButtonGap);
  document.addEventListener('shopify:block:select', moveHeroButtonGap);
})();



// Patch scrolling-text-banner to render HTML entities (e.g. &nbsp;) as actual spaces
(function () {
  const _define = customElements.define.bind(customElements);
  customElements.define = function (name, constructor, options) {
    if (name === 'scrolling-text-banner') {
      constructor.prototype.initializeScrollingText = function () {
        const heroTitle = this.querySelector('.hero__title');
        if (!heroTitle) return;

        // textContent decodes &amp;nbsp; → &nbsp; (the HTML entity string)
        const textContent = heroTitle.textContent.trim();
        if (!textContent) return;

        heroTitle.innerHTML = '';

        const scrollingContainer = document.createElement('div');
        scrollingContainer.classList.add('scrolling-container');
        heroTitle.appendChild(scrollingContainer);

        for (let i = 0; i < 2; i++) {
          const wrapper = document.createElement('div');
          wrapper.classList.add('scrolling-wrapper');

          for (let j = 0; j < this.itemIteration; j++) {
            const textWrapper = document.createElement('div');
            textWrapper.classList.add('scrolling-text');
            if (this.showDots == 'true') {
              // innerHTML interprets &nbsp; as a non-breaking space instead of literal text
              textWrapper.innerHTML = textContent + this.dot;
              textWrapper.style.marginRight = `${this.spacing}px`;
              textWrapper.style.gap = `${this.spacing}px`;
            } else {
              textWrapper.innerHTML = textContent;
              textWrapper.style.marginRight = `${this.spacing}px`;
            }
            wrapper.appendChild(textWrapper);
          }

          scrollingContainer.appendChild(wrapper);
        }

        this.setAnimationSpeed(scrollingContainer);
      };
    }
    return _define(name, constructor, options);
  };
})();



// date calculator of shipping
function getShippingEndDate(businessDays = 5) {
  const today = new Date();
  let endDate = new Date(today);
  let addedDays = 0;

  while (addedDays < businessDays) {
    endDate.setDate(endDate.getDate() + 1);
    if (endDate.getDay() !== 0 && endDate.getDay() !== 6) {
      addedDays++;
    }
  }

  const options = { weekday: 'long', day: 'numeric', month: 'short' };
  return endDate.toLocaleDateString(undefined, options);
}

function updateShippingDates(context = document) {
  const textBlocks = context.querySelectorAll('.wt-product__text-block');

  textBlocks.forEach(block => {
    if (block.textContent.includes('[DATE]')) {
      const shippingDate = getShippingEndDate();
      block.innerHTML = block.innerHTML.replace(
        '[DATE]',
        `<span class="shipping-date">${shippingDate}</span>`
      );
    }
  });
}

// Run on normal page load (PDP)
document.addEventListener('DOMContentLoaded', () => {
  updateShippingDates();
});

// Run again when Quick View opens (observe DOM changes)
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1 && node.querySelector('.wt-product__text-block')) {
        updateShippingDates(node);
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

// date calculator of shipping